export default "{\n    \"label\": \"Expected Service Timeline\"\n}\n"